import React from 'react';
import { Divider, List, ListItem, ListItemText } from '@mui/material';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { noop } from 'lodash';
import { useLevels } from "@dyl/systems/LevelsManager";
import makeStyles from "@mui/styles/makeStyles";
import { useRoles } from '@dyl/systems/RolesContext';

const useStyles = makeStyles(theme => ({
    divider: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
}));

/**
 *
 * @param {Object} props
 * @param {{ slug: string, title: string }[]} props.links
 * @param {(event: MouseEvent, slug: string) => void} [props.onLinkClick]
 */
export default function NavLinks({
    links = [],
    onLinkClick = noop,
    ...other
}) {
    const { pathname: currentPath } = useLocation();
    const { globalLevel } = useLevels();


    const classes = useStyles();
    const { roleNames } = useRoles();
    const filtered_links = links.filter(item=>item.allowedRoles.some(role => roleNames.includes(role)));

    return (
        <List component='nav' {...other}>
            {filtered_links.map(({ type, slug, title }, index) => {
                const params = { level_label: globalLevel.label, currentPath };
                slug = slug?.(params);
                title = typeof title === 'function' ? title(params) : title;
                if (title === 'Misspelling Words' && (params.level_label === 'Pre-A1')) return<></>
                if (title === 'ARC AI Automarker template' && (params.level_label !== 'A2')) return<></>
                return (
                    type === 'Link'
                        ? <ListItem
                            key={index}
                            button
                            selected={currentPath.startsWith(slug)}
                            component={Link}
                            to={slug}
                            onClick={e => onLinkClick(e, slug)}
                        >
                            <ListItemText primary={title} />
                        </ListItem>
                        : <Divider key={index} className={classes.divider} />
                )
            })}
        </List>
    );
};